import { Movie } from '../types/movie';

// 电影数据库 - 初始版本包含精选电影
// 注意：这里使用的是示例海报URL，实际部署时需要替换为合法的海报图片
export const MOVIES_DATABASE: Movie[] = [
  {
    id: '1',
    title: '肖申克的救赎',
    titleEn: 'The Shawshank Redemption',
    year: 1994,
    director: '弗兰克·德拉邦特',
    actors: ['蒂姆·罗宾斯', '摩根·弗里曼'],
    genre: ['剧情'],
    tags: ['希望', '友谊', '自由', '经典', '励志'],
    rating: {
      douban: 9.7,
      imdb: 9.3
    },
    poster: 'https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?w=300&h=450&fit=crop',
    description: '银行家安迪被冤枉杀妻入狱，他在肖申克监狱中保持希望，用二十年时间挖通地道，最终重获自由。',
    recommendation: '当你感到绝望时，这部电影会告诉你：希望是美好的，也许是人间至善，而美好的事物永不消逝。',
    links: {
      douban: 'https://movie.douban.com/subject/1292052/',
      imdb: 'https://www.imdb.com/title/tt0111161/'
    }
  },
  {
    id: '2',
    title: '霸王别姬',
    titleEn: 'Farewell My Concubine',
    year: 1993,
    director: '陈凯歌',
    actors: ['张国荣', '张丰毅', '巩俐'],
    genre: ['剧情', '爱情'],
    tags: ['艺术', '人生', '历史', '悲剧', '经典'],
    rating: {
      douban: 9.6,
      imdb: 8.5
    },
    poster: 'https://images.unsplash.com/photo-1536440136628-849c177e76a1?w=300&h=450&fit=crop',
    description: '程蝶衣和段小楼从小在戏班学艺，两人合演的《霸王别姬》誉满京城，却也因时代变迁和情感纠葛走向悲剧。',
    recommendation: '华语电影巅峰之作，在动荡的时代中，关于艺术、关于人生、关于爱与背叛的深刻探讨。',
    links: {
      douban: 'https://movie.douban.com/subject/1291546/',
      imdb: 'https://www.imdb.com/title/tt0106332/'
    }
  },
  {
    id: '3',
    title: '这个杀手不太冷',
    titleEn: 'Léon: The Professional',
    year: 1994,
    director: '吕克·贝松',
    actors: ['让·雷诺', '娜塔莉·波特曼', '加里·奥德曼'],
    genre: ['剧情', '动作'],
    tags: ['温情', '救赎', '孤独', '成长', '经典'],
    rating: {
      douban: 9.4,
      imdb: 8.5
    },
    poster: 'https://images.unsplash.com/photo-1594909122845-11baa439b7bf?w=300&h=450&fit=crop',
    description: '职业杀手莱昂收留了被杀全家的小女孩玛蒂尔达，两人在互相救赎中建立起深厚的情感纽带。',
    recommendation: '当一个冷酷的杀手遇到了一个需要保护的小女孩，温情在危险中绽放，孤独的心灵找到了慰藉。',
    links: {
      douban: 'https://movie.douban.com/subject/1292213/',
      imdb: 'https://www.imdb.com/title/tt0110413/'
    }
  },
  {
    id: '4',
    title: '泰坦尼克号',
    titleEn: 'Titanic',
    year: 1997,
    director: '詹姆斯·卡梅隆',
    actors: ['莱昂纳多·迪卡普里奥', '凯特·温斯莱特'],
    genre: ['爱情', '灾难'],
    tags: ['浪漫', '悲剧', '史诗', '经典', '爱情'],
    rating: {
      douban: 9.4,
      imdb: 7.9
    },
    poster: 'https://images.unsplash.com/photo-1534809027769-b00d750a6bac?w=300&h=450&fit=crop',
    description: '在泰坦尼克号的沉船灾难中，来自不同阶层的杰克和露丝相遇相爱，演绎了一段跨越生死的爱情传奇。',
    recommendation: '永恒的爱情史诗，"You jump, I jump"——当爱情面临生死考验，你会如何选择？',
    links: {
      douban: 'https://movie.douban.com/subject/1292720/',
      imdb: 'https://www.imdb.com/title/tt0120338/'
    }
  },
  {
    id: '5',
    title: '千与千寻',
    titleEn: "Spirited Away",
    year: 2001,
    director: '宫崎骏',
    actors: ['柊瑠美', '入野自由'],
    genre: ['动画', '奇幻', '冒险'],
    tags: ['成长', '勇气', '治愈', '奇幻', '经典'],
    rating: {
      douban: 9.4,
      imdb: 8.6
    },
    poster: 'https://images.unsplash.com/photo-1518709268805-4e9042af9f23?w=300&h=450&fit=crop',
    description: '十岁的千寻误入神灵世界，为救变成猪的父母，她在汤婆婆的澡堂工作，经历了一段奇幻的成长之旅。',
    recommendation: '宫崎骏巅峰之作，关于成长、关于勇气、关于不忘初心的童话，治愈每一个迷失的成年人。',
    links: {
      douban: 'https://movie.douban.com/subject/1291561/',
      imdb: 'https://www.imdb.com/title/tt0245429/'
    }
  },
  {
    id: '6',
    title: '盗梦空间',
    titleEn: 'Inception',
    year: 2010,
    director: '克里斯托弗·诺兰',
    actors: ['莱昂纳多·迪卡普里奥', '约瑟夫·高登-莱维特', '艾伦·佩吉'],
    genre: ['科幻', '动作', '悬疑'],
    tags: ['梦境', '悬疑', '烧脑', '动作', '经典'],
    rating: {
      douban: 9.3,
      imdb: 8.8
    },
    poster: 'https://images.unsplash.com/photo-1478720568477-152d9b164e26?w=300&h=450&fit=crop',
    description: '柯布是一名能够进入他人梦境盗取机密的"盗梦者"，他接到了一个看似不可能的任务：在梦中植入一个想法。',
    recommendation: '诺兰经典之作，层层嵌套的梦境世界，让人分不清虚幻与现实，烧脑又震撼。',
    links: {
      douban: 'https://movie.douban.com/subject/3541415/',
      imdb: 'https://www.imdb.com/title/tt1375666/'
    }
  },
  {
    id: '7',
    title: '楚门的世界',
    titleEn: 'The Truman Show',
    year: 1998,
    director: '彼得·威尔',
    actors: ['金·凯瑞', '劳拉·琳妮'],
    genre: ['剧情', '科幻'],
    tags: ['自由', '真实', '人生', '思考', '经典'],
    rating: {
      douban: 9.3,
      imdb: 8.2
    },
    poster: 'https://images.unsplash.com/photo-1485846234645-a62644f84728?w=300&h=450&fit=crop',
    description: '楚门从出生起就生活在一个巨大的真人秀节目中，他身边的一切都是假的，直到有一天他发现了真相。',
    recommendation: '如果你发现你的人生是一场被操控的表演，你会选择留在舒适的虚假中，还是冲向未知的真实？',
    links: {
      douban: 'https://movie.douban.com/subject/1292063/',
      imdb: 'https://www.imdb.com/title/tt0120382/'
    }
  },
  {
    id: '8',
    title: '三傻大闹宝莱坞',
    titleEn: '3 Idiots',
    year: 2009,
    director: '拉吉库马尔·希拉尼',
    actors: ['阿米尔·汗', '马德哈万', '沙尔曼·乔希'],
    genre: ['喜剧', '剧情'],
    tags: ['教育', '友情', '励志', '喜剧', '经典'],
    rating: {
      douban: 9.2,
      imdb: 8.4
    },
    poster: 'https://images.unsplash.com/photo-1517604931442-7e0c8ed2963c?w=300&h=450&fit=crop',
    description: '三个工程系大学好友用他们的方式对抗刻板的教育体制，追求真正的热爱和梦想。',
    recommendation: '"All is well"——用幽默的方式反思教育，关于梦想、友情和追求卓越的励志喜剧。',
    links: {
      douban: 'https://movie.douban.com/subject/3793023/',
      imdb: 'https://www.imdb.com/title/tt1187043/'
    }
  },
  {
    id: '9',
    title: '机器人总动员',
    titleEn: 'WALL·E',
    year: 2008,
    director: '安德鲁·斯坦顿',
    actors: ['本·贝尔特', '艾丽莎·奈特'],
    genre: ['动画', '科幻', '爱情'],
    tags: ['爱情', '环保', '治愈', '科幻', '经典'],
    rating: {
      douban: 9.3,
      imdb: 8.4
    },
    poster: 'https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?w=300&h=450&fit=crop',
    description: '地球上的垃圾清理机器人瓦力爱上了高科技机器人伊娃，两人展开了一场跨越太空的冒险。',
    recommendation: '皮克斯经典之作，用最可爱的机器人讲述关于爱、环保和人性的深刻故事。',
    links: {
      douban: 'https://movie.douban.com/subject/2131458/',
      imdb: 'https://www.imdb.com/title/tt0910970/'
    }
  },
  {
    id: '10',
    title: '放牛班的春天',
    titleEn: "Les Choristes",
    year: 2004,
    director: '克里斯托夫·巴拉蒂',
    actors: ['热拉尔·朱诺', '让-巴蒂斯特·莫尼耶'],
    genre: ['剧情', '音乐'],
    tags: ['教育', '温情', '音乐', '治愈', '经典'],
    rating: {
      douban: 9.3,
      imdb: 7.9
    },
    poster: 'https://images.unsplash.com/photo-1507838153414-b4b713384a76?w=300&h=450&fit=crop',
    description: '怀才不遇的音乐家马修来到一所寄宿学校当助理教师，他组织了一支合唱团，用音乐改变了孩子们的人生。',
    recommendation: '音乐的力量是无穷的，即使在最黑暗的地方，艺术也能点亮希望之光。',
    links: {
      douban: 'https://movie.douban.com/subject/1291547/',
      imdb: 'https://www.imdb.com/title/tt0372864/'
    }
  },
  {
    id: '11',
    title: '大话西游之大圣娶亲',
    titleEn: 'A Chinese Odyssey Part Two',
    year: 1995,
    director: '刘镇伟',
    actors: ['周星驰', '朱茵', '吴孟达'],
    genre: ['喜剧', '爱情', '奇幻'],
    tags: ['爱情', '喜剧', '无厘头', '经典', '感人'],
    rating: {
      douban: 9.2,
      imdb: 7.6
    },
    poster: 'https://images.unsplash.com/photo-1535016120720-40c646be5580?w=300&h=450&fit=crop',
    description: '至尊宝为了救白晶晶穿越回五百年前，却遇到了紫霞仙子，展开了一段跨越时空的爱情悲剧。',
    recommendation: '周星驰巅峰之作，表面无厘头搞笑，实则深刻探讨爱情与命运，"曾经有一份真诚的爱情..."',
    links: {
      douban: 'https://movie.douban.com/subject/1292215/',
      imdb: 'https://www.imdb.com/title/tt0112777/'
    }
  },
  {
    id: '12',
    title: '疯狂动物城',
    titleEn: 'Zootopia',
    year: 2016,
    director: '拜伦·霍华德、瑞奇·摩尔',
    actors: ['金妮弗·古德温', '杰森·贝特曼'],
    genre: ['动画', '喜剧', '冒险'],
    tags: ['梦想', '友情', '社会', '动画', '经典'],
    rating: {
      douban: 9.2,
      imdb: 8.0
    },
    poster: 'https://images.unsplash.com/photo-1459183885421-5cc683b8dbba?w=300&h=450&fit=crop',
    description: '兔子朱迪实现了成为警察的梦想，在动物乌托邦"疯狂动物城"与狐狸尼克联手破案，揭开城市背后的阴谋。',
    recommendation: '迪士尼经典，用可爱的动物讲述关于梦想、偏见和友情的故事，老少皆宜。',
    links: {
      douban: 'https://movie.douban.com/subject/2566233/',
      imdb: 'https://www.imdb.com/title/tt2948356/'
    }
  },
  {
    id: '13',
    title: '控方证人',
    titleEn: 'Witness for the Prosecution',
    year: 1957,
    director: '比利·怀德',
    actors: ['泰隆·鲍华', '玛琳·黛德丽', '查尔斯·劳顿'],
    genre: ['剧情', '悬疑'],
    tags: ['法庭', '悬疑', '反转', '经典', '黑白'],
    rating: {
      douban: 9.6,
      imdb: 8.5
    },
    poster: 'https://images.unsplash.com/photo-1500462918059-b1a0cb512f1d?w=300&h=450&fit=crop',
    description: '一位温和的退休律师接手了一桩谋杀案，被告的妻子作为控方证人出庭，案情却出现惊人反转。',
    recommendation: '悬疑片黄金时代杰作，比利·怀德导演，剧情反转让人意想不到，结尾震撼。',
    links: {
      douban: 'https://movie.douban.com/subject/1292210/',
      imdb: 'https://www.imdb.com/title/tt0050718/'
    }
  },
  {
    id: '14',
    title: '忠犬八公的故事',
    titleEn: 'Hachi: A Dog\'s Tale',
    year: 2009,
    director: '拉斯·霍尔斯道姆',
    actors: ['理查·基尔', '琼·艾伦'],
    genre: ['剧情'],
    tags: ['温情', '动物', '感人', '治愈', '经典'],
    rating: {
      douban: 9.4,
      imdb: 8.1
    },
    poster: 'https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=300&h=450&fit=crop',
    description: '基于真实故事，一只名叫八公的秋田犬每天在车站等待主人归来，即使主人去世后，它依然坚持等待了十年。',
    recommendation: '最感人的人狗情缘，忠诚的等待跨越生死的界限，让无数人流泪。',
    links: {
      douban: 'https://movie.douban.com/subject/3017044/',
      imdb: 'https://www.imdb.com/title/tt1024734/'
    }
  },
  {
    id: '15',
    title: '触不可及',
    titleEn: 'The Intouchables',
    year: 2011,
    director: '奥利维·那卡什、艾力克·托兰达',
    actors: ['弗朗索瓦·克鲁塞', '奥玛·赛'],
    genre: ['剧情', '喜剧'],
    tags: ['友情', '温情', '励志', '真实', '经典'],
    rating: {
      douban: 9.3,
      imdb: 8.5
    },
    poster: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=300&h=450&fit=crop',
    description: '一位富有的瘫痪男子招聘了一位有犯罪记录的贫民区黑人作为护工，两个截然不同的人建立起了深厚的友谊。',
    recommendation: '基于真实故事，关于阶级、种族、友情和生命态度的温暖喜剧，法国电影票房奇迹。',
    links: {
      douban: 'https://movie.douban.com/subject/6399524/',
      imdb: 'https://www.imdb.com/title/tt1675434/'
    }
  }
];

// 获取所有电影的函数
export function getAllMovies(): Movie[] {
  return MOVIES_DATABASE;
}

// 根据ID获取电影
export function getMovieById(id: string): Movie | undefined {
  return MOVIES_DATABASE.find(movie => movie.id === id);
}

// 根据标签搜索电影
export function searchMoviesByTags(tags: string[]): Movie[] {
  return MOVIES_DATABASE.filter(movie =>
    tags.some(tag => movie.tags.includes(tag))
  );
}

// 根据类型搜索电影
export function searchMoviesByGenre(genre: string): Movie[] {
  return MOVIES_DATABASE.filter(movie =>
    movie.genre.includes(genre)
  );
}
